module.exports = __webpack_public_path__ + "static/media/patra.dc7b4398.jpg";